import { create } from 'zustand';

// eslint-disable-next-line import/prefer-default-export
export const useCsvPerformanceStore = create(setState => ({
  selectedUsers: [],
  selectedTemplates: [],
  selectedESPs: [],
  search: '',
  page: 1,
  limit: 10,
  setSelectedUsers: selectedUsers => setState({ selectedUsers }),
  setSelectedTemplates: selectedTemplates => setState({ selectedTemplates }),
  setSelectedESPs: selectedESPs => setState({ selectedESPs }),
  setSearch: search => setState({ search }),
  setPage: page => setState({ page }),
  setLimit: limit => setState({ limit }),
}));
